<template>
  <div id="main-wrapper">
    <div v-if="success">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div
        class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready"
        tabindex="-1"
        style="overflow: hidden auto"
      >
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div
              id="upload-confirm"
              class="white-popup-block popup-content popup-small"
            >
              <div class="content t-white t-left">
                <p>{{$t("request_call.success_message")}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="success = false">
                  {{$t("request_call.ok")}}
                </a>
              </div>
              <button
                title="Close (Esc)"
                type="button"
                class="mfp-close"
                @click.prevent="success = false"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container profile-page personal-details request-call">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder wow fadeInLeft">
              <h4>{{$t("request_call.request_call_back")}}</h4>
            </div>
            <div class="content-holder wow fadeInLeft">
              <div class="row-sec">
                <div class="form-holder">
                  <Form @submit="submit">
                    <ul class="clearfix overflowHidden">
                      <li class="half-width f-left">
                        <label for="">{{$t("request_call.first_name")}}</label>
                        <Field
                          name="First Name"
                          v-model="form.fname"
                          rules="required"
                        />
                        <ErrorMessage name="First Name" />
                      </li>
                      <li class="half-width f-right">
                        <label for="">{{$t("request_call.last_name")}}</label>
                        <Field
                          name="Last Name"
                          v-model="form.lname"
                          rules="required"
                        />
                        <ErrorMessage name="Last Name" />
                      </li>
                      <li class="clearfix"></li>
                      <li class="half-width f-left">
                        <label for="">{{$t("request_call.email_id")}}</label>
                        <Field
                          rules="required"
                          name="Email ID"
                          v-model="form.email"
                          id="email"
                        />
                        <ErrorMessage name="Email ID" />
                      </li>
                      <li class="half-width f-right">
                        <label for="">{{$t("request_call.phone_number")}}</label>
                        <Field
                          v-slot="{ field }"
                          name="Phone Number"
                          rules="required"
                          v-model="form.mobile"
                        >
                          <vue-tel-input
                            v-bind="field"
                            v-model="form.mobile"
                            @change="onInput"
                            @country-changed="GetCode"
                            defaultCountry="IN"
                          ></vue-tel-input>
                        </Field>
                        <!-- <Field
                          rules="required"
                          name="Phone Number"
                          v-model="form.mobile"
                          id="phone"
                          style="display: none"
                        /> -->
                        <ErrorMessage name="Phone Number" />
                      </li>
                      <li class="clearfix"></li>
                      <li class="fullscreen">
                        <label for="">{{$t("request_call.timezone")}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          rules="required"
                          name="timezone"
                          v-model="form.timezone"
                        >
                          <option
                            :key="tz.value"
                            v-for="tz of static_vars.timezones"
                            :value="tz.value"
                          >
                            {{ tz.label }}
                          </option>
                        </Field>
                      </li>
                      <li class="clearfix"></li>
                      <li class="half-width f-left">
                        <label for="">{{$t("request_call.date")}}</label>
                        <Field
                          name="Date"
                          v-model="form.date"
                          rules="required"
                          class="datepicker"
                        >
                          <input
                            type="date"
                            v-model="form.date"
                            :min="form.minDate"
                          />
                        </Field>
                        <ErrorMessage name="Date" />
                        <!-- <p v-if="form.date">GMT: {{ dateGMT() }}</p> -->
                      </li>
                      <li class="half-width f-right">
                        <label for="">{{$t("request_call.preferred_time")}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="Preferred Time"
                          v-model="form.preferred_time"
                        >
                          <option value="" disabled>
                            {{$t("request_call.preferred_time")}}
                          </option>
                          <option value="8-10">8:00 - 10:00</option>
                          <option value="10-12">10:00 - 12:00</option>
                          <option value="12-14">12:00 - 14:00</option>
                          <option value="14-16">14:00 - 16:00</option>
                          <option value="16-18">16:00 - 18:00</option>
                          <option value="18-20">18:00 - 20:00</option>
                        </Field>
                        <ErrorMessage name="Preferred Time" />
                      </li>
                      <li class="clearfix"></li>
                      <li class="full-width f-left">
                        <label for="">{{$t("request_call.department")}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="Department"
                          v-model="form.department"
                        >
                          <option value="" disabled>{{$t("request_call.select_department")}}</option>
                          <option value="New Accounts">{{$t("request_call.new_accounts")}}</option>
                          <option value="Deposits">{{$t("request_call.deposits")}}</option>
                          <option value="Withdrawals">{{$t("request_call.withdrawals")}}</option>
                          <option value="Partnership">{{$t("request_call.partnership")}}</option>
                          <option value="Technical Support">{{$t("request_call.technical_support")}}</option>
                        </Field>
                        <ErrorMessage name="Department" />
                      </li>
                      <li class="clearfix"></li>
                      <li class="full-width f-left">
                        <label for="">{{$t("request_call.message")}}</label>
                        <Field
                          v-slot="{ field }"
                          rows="8"
                          name="Message"
                          rules="required|min:10"
                          v-model="form.message"
                        >
                          <textarea
                            v-bind="field"
                            rows="8"
                            cols="80"
                          ></textarea>
                        </Field>
                        <ErrorMessage name="Message" />
                      </li>
                      <li class="clearfix"></li>
                    </ul>
                    <div class="btn-holder t-center">
                      <button type="submit" class="btn btn-blue popup-link-holder">
                        {{$t("request_call.send_request")}}
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div class="img-holder t-center wow fadeInRight va-top">
              <img src="assets/images/req-img.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import moment from "moment";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      minDate: new Date(),
      success: false,
      form: {
        fname: "",
        lname: "",
        email: "",
        preferred_time: "",
        department: "",
        timezone: "",
        date: null,
        mobile: "",
        message: "",
        minDate: moment().format("YYYY-MM-DD"),
      },
      phoneCode: "",
      phoneNo: "",
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  mounted() {
    const start = moment();
    const remainder = 180 - (start.minute() % 60);
    this.form.date = moment(start).add(remainder, "minutes");
  },

  methods: {
    onInput(e) {
      console.log(e, this.phoneCode);
      this.phoneNo = e.target.value;
    },
    GetCode(e) {
      console.log(e.dialCode);
      this.phoneCode = e.dialCode;
    },
    submit() {
      const description = `
        A callback request has been generated on client portal. Please check the below details
        <br /><br />
        <b>First Name: </b> ${this.form.fname} ${this.form.lname}<br />
        <b>Email: </b> ${this.form.email}<br />
        <b>Phone Number: </b> ${this.phoneCode} ${this.phoneNo}<br />
        <b>Date & Time: </b> ${moment(this.form.date).format(
          "Do MMM, YYYY"
        )} (GMT: ${this.dateGMT()})<br />
        <b>Preferred Time: </b> ${this.form.preferred_time}<br />
        <b>TimeZone: </b> ${this.form.timezone}<br />
        <b>Department: </b> ${this.form.department}<br />
        <b>Message: </b> ${this.form.message}<br />
      `;
      let formData = {
        description,
        title: "REQUEST CALLBACK",
      };
      // console.log(formData);
      this.store.requestCallback(formData, true, this);
    },
    dateGMT() {
      if (this.form.date) {
        return moment(this.form.date).utc();
      } else {
        return null;
      }
    },
  },
};
</script>
